import { createReturnReasonConfigStuff } from "../mockCore";

export function getExchange({ productId }) {
    if (productId === "1") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/sony black.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "2") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/magic mouse black.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "3") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/otterbox grey.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Grey",
                        },
                    ],
                },
            ],
        };
    }
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        pickupDateSelectionAllowed: true,
        paidShipping: 40,
        turnrShippingCost: 59,
        currencyCode: "SEK",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: [
            {
                productVariantId: 10,
                sessionItemId: 1,
                productName: "Sony WF-1000XM4",
                imageSrc: "/mocks/sony white.png",
                imageAlt: "/mocks/sony white.png",
                quantity: 1,
                purchasePrice: 2790,
                properties: [
                    {
                        type: "Color",
                        value: "Silver",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigStuff(),
            },
            {
                productVariantId: 10,
                sessionItemId: 2,
                productName: "Apple Magic Mouse",
                imageSrc: "/mocks/magic mouse white.png",
                imageAlt: "/mocks/magic mouse white.png",
                quantity: 1,
                purchasePrice: 895,
                properties: [
                    {
                        type: "Color",
                        value: "White",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigStuff(),
            },
            {
                productVariantId: 10,
                sessionItemId: 3,
                productName: "Otterbox Iphone 13 skal",
                imageSrc: "/mocks/otterbox iphone 13 skal.png",
                imageAlt: "/mocks/otterbox iphone 13 skal.png",
                quantity: 1,
                purchasePrice: 499,
                properties: [
                    {
                        type: "Color",
                        value: "Black",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigStuff(),
            },
        ],
    };
}
